import { Avatar } from '@mui/material';
import { IconLibrary } from '../IconLibrary/IconLibrary';
import { ICON_AVATAR_MAP, IconAvatarType } from './IconAvatarMap';

interface IconAvatarProps {
  avatarType: IconAvatarType;
  /**
   * Size of the icon in pixels (default: 24)
   * Avatar will automatically size to fit icon with padding
   */
  size?: number;
  /**
   * Padding around the icon in pixels (default: 8)
   */
  padding?: number;
}

export type { IconAvatarType };

export const IconAvatar = ({
  avatarType,
  size = 24,
  padding = 1.5,
}: IconAvatarProps) => {
  const { iconName, iconColor } = ICON_AVATAR_MAP[avatarType] || {
    iconName: 'X',
    iconColor: 'neutral',
  };

  const avatarSize = 'fit-content';

  return (
    <Avatar
      className={iconColor}
      sx={{
        width: avatarSize,
        height: avatarSize,
        padding: padding,
      }}
    >
      <IconLibrary iconName={iconName} size={size} />
    </Avatar>
  );
};
